import { type Breakpoint } from 'common-js/hooks/useWindowSize';
import { createContext } from 'react';

const DeviceContext = createContext<Breakpoint | undefined>(undefined);

export default DeviceContext;
